import Components from 'vendor/onpay/laravel-core/resources/js/alpine-components/index';

export default Object.freeze({
    ...Components,
});
